import { Guid } from 'guid-typescript';

export class AutocompleteDto {
 public id: Guid;
 public descricao: string;
 public nome?: string;

  constructor(object?: any) {
    if (object) {
      Object.assign(this, object);
    }
  }
}
